/* TextInput.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ErrorMessage, Field, HelperMessage } from '@atlaskit/form';
import TextArea from '@atlaskit/textarea';
import TextField from '@atlaskit/textfield';
import React, { useCallback } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _ = "._1bsb1rkg{width:var(--_1gljcou)}";
const InputWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_1gljcou": ix(__cmplp.width)
      }),
      ref: __cmplr,
      className: ax(["_1bsb1rkg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InputWrapper.displayName = 'InputWrapper';
}
const isBlank = value => !value || value.trim() === '';
const isValidUrl = value => {
  const validUrlRegex = /^(https?):\/\/[^\s/$.?#].\S*$/i;
  return value ? validUrlRegex.test(value) : true;
};
const isValidEmail = value => {
  return value ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) : true;
};
const isValidNumber = value => {
  return value ? !isNaN(Number(value)) : true;
};
const getValidationForType = type => {
  switch (type) {
    case 'url':
      return isValidUrl;
    case 'email':
      return isValidEmail;
    case 'number':
      return isValidNumber;
  }
};
const TextInput = _ref2 => {
  let {
    defaultValue = '',
    helperMessage,
    isCompact,
    fieldType = 'textfield',
    type,
    isRequired,
    label,
    name,
    onChange: _onChange,
    placeholder,
    validate,
    isDisabled,
    width,
    applyDefaultValidation,
    submissionError,
    testId
  } = _ref2;
  const Input = fieldType === 'textarea' ? TextArea : TextField;
  const validateWithDefaults = useCallback((value, formState) => {
    if (isRequired && isBlank(value)) {
      return "".concat(label, " cannot be blank");
    }
    if (type) {
      const validationFn = getValidationForType(type);
      if (validationFn && !validationFn(value)) {
        return "Please enter a valid ".concat(type);
      }
    }
    return validate === null || validate === void 0 ? void 0 : validate(value, formState);
  }, [isRequired, type, validate, label]);
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    label: label,
    isRequired: isRequired,
    validate: applyDefaultValidation ? validateWithDefaults : validate,
    defaultValue: defaultValue,
    isDisabled: isDisabled,
    testId: testId,
    children: _ref3 => {
      let {
        fieldProps,
        meta: {
          error,
          submitFailed
        }
      } = _ref3;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(InputWrapper, {
          width: width,
          children: /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({}, fieldProps), {}, {
            isCompact: isCompact,
            type: type,
            placeholder: placeholder,
            onChange: e => {
              fieldProps.onChange(e);
              _onChange === null || _onChange === void 0 ? void 0 : _onChange(e.target.value);
            }
          }))
        }), error && submitFailed && /*#__PURE__*/_jsx(ErrorMessage, {
          testId: "".concat(name, "-text-field-error"),
          children: error
        }), !error && submissionError && /*#__PURE__*/_jsx(ErrorMessage, {
          testId: "".concat(name, "-submission-error"),
          children: submissionError
        }), helperMessage && /*#__PURE__*/_jsx(HelperMessage, {
          children: helperMessage
        })]
      });
    }
  });
};
export default TextInput;